import { render, staticRenderFns } from "./FormProduto.vue?vue&type=template&id=1f02013f"
import script from "./FormProduto.vue?vue&type=script&lang=ts"
export * from "./FormProduto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports